import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormatDateActionFields',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Date): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: Date | string | null
};





const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(props.value) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(props.value) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  emit('input', formLib.getToday())
}

function setTomorrow() {
  emit('input', formLib.getTommorow())
}

function onInput(next: Date) {
  emit('input', next)
}

return { __sfc: true,props, emit, formLibRaw, formLib, isTodaySelected, isTomorrowSelected, setToday, setTomorrow, onInput }
}

})